import React from 'react';
import s from './s.module.less';
import { getAskChartDemoUrl } from 'constants/common';
import askChartIcon from './imgs/askchart-icon.svg';

type Props = {
    onClose: () => void;
};

const AskChartCalendarBanner = (props: Props) => {
    const { onClose } = props;

    return (
        <div className={s.wrap}>
            <div className={s.iconWrap}>
                <img src={askChartIcon} alt="AskChart" className={s.icon} />
            </div>
            <div className={s.text}>
                Checking appointments across multiple EHRs? AskChart, from Klarity Health, automatically syncs your
                Klarity patients and appointments to Healthie, IntakeQ, Tebra, SimplePractice and more.
            </div>
            <a
                className={s.cta}
                href={getAskChartDemoUrl()}
                target="_blank"
                rel="noopener noreferrer"
            >
                Book a demo
            </a>
            <span className={s.close} onClick={onClose} role="button" aria-label="Close" tabIndex={0}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M2 14L14 2M2 2L14 14"
                        stroke="#9CA3AF"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </div>
    );
};

export default AskChartCalendarBanner;
